/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Palette(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200.772,53.88965A103.28,103.28,0,0,0,127.99756,24q-.53247,0-1.06543.00488a104.01647,104.01647,0,0,0-33.57227,202.084A32.00105,32.00105,0,0,0,136,195.90234V192a16.01833,16.01833,0,0,1,16-16h46.20947a31.81973,31.81973,0,0,0,31.20508-24.87207,104.49414,104.49414,0,0,0,2.58154-24.01953A103.2063,103.2063,0,0,0,200.772,53.88965ZM88.96667,164.39209A12,12,0,1,1,93.359,148,11.99983,11.99983,0,0,1,88.96667,164.39209ZM93.359,108a12,12,0,1,1-4.39234-16.39258A12,12,0,0,1,93.359,108ZM128,88a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm51.03333,24.39209A12,12,0,1,1,183.42566,96,11.99981,11.99981,0,0,1,179.03333,112.39209Z" />
    </Svg>
  );
}

export default Palette;
